<div mat-dialog-title id="subscription-successful">Subscription Successful
    <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
        <img src="/assets/images/close-popup.png">
      </a>
    </div>
</div>
<form>
    <div mat-dialog-content cdkFocusInitial>
      <p class="cartText" name="date" id="success-msg"
      >Your subscription was successful. First shipment will be shipped on {{date | date:'longDate'}} and later shipment will follow the subscription options chosen.</p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]="false" id="btn-ok" class="ok">OK</button>
    </div>

</form>

